import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { SessionService } from '../core/session.service';

@Component({
  selector: 'ch-admin-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './admin-layout.component.html'
})
export class AdminLayoutComponent {
  constructor(private readonly session: SessionService, private readonly router: Router) {}

  logout(): void {
    this.session.clear();
    void this.router.navigateByUrl('/login');
  }
}
